import api from '@/apis/gl/gLVoucherAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('gLVoucher', api);

const state = {
  ...crud.state,
  _config: {
    table: 'gl_voucher',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Load dữ liệu mặc định
   */
  async glProfitLossDefaultData(context, payload) {
    let res = null;
    payload = payload || {};
    try {
      context.commit('updateLoading', true);
      res = await api.getProfitLossTransferDefaultData(payload);
    } finally {
      context.commit('updateLoading', false);
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
